/**
 * Ultimo foglio task visualizzato per utente + progetto (localStorage).
 */
const STORAGE_PREFIX = 'brain_task_sheet_';

function storageKey(projectId, userId) {
    return STORAGE_PREFIX + userId + '_' + projectId;
}

function getLastTaskSheet(projectId, userId, validSheetIds) {
    if (!projectId || !userId) {
        return 'all';
    }

    const key = storageKey(projectId, userId);
    let value = 'all';

    try {
        value = localStorage.getItem(key) || 'all';
    } catch (e) {
        return 'all';
    }

    if (value === 'all' || value === '') {
        return 'all';
    }

    const numericId = parseInt(value, 10);
    if (!numericId || !Array.isArray(validSheetIds) || !validSheetIds.includes(numericId)) {
        try {
            localStorage.setItem(key, 'all');
        } catch (err) {
            // ignore
        }

        return 'all';
    }

    return String(numericId);
}

function setLastTaskSheet(projectId, userId, sheetIdOrAll) {
    if (!projectId || !userId) {
        return;
    }

    const key = storageKey(projectId, userId);
    const value = sheetIdOrAll === 'all' || sheetIdOrAll === null || sheetIdOrAll === undefined
        ? 'all'
        : String(sheetIdOrAll);

    try {
        localStorage.setItem(key, value);
    } catch (e) {
        // ignore
    }
}

module.exports = {
    getLastTaskSheet,
    setLastTaskSheet,
    storageKey,
};
